import { createLogic, Logic } from "redux-logic";
import store from "configureStore";
import {ITransportType} from '../reducer/user';

import {
    actions as filtersActions,
    actionTypes as filtersTypes,
    IBranch,
    IDepot,
    IFilter,
    IFilterRoute,
    IFilterState,
    IParsedFilters,
    IParsedVehicle,
    IVehicle
} from "reducer/vehicleFilters";

import { actions as appActions } from "reducer/app";

import { getFilters } from "api/video/filters";
import { Observable } from "rxjs";

const filtersLogic = createLogic({
    type: filtersTypes.GET_FILTERS,
    latest: true,
    warnTimeout: 0,

    async process({getState, action$}: { getState: () => IFilterState, action$: Observable<{}>}, dispatch, done) {
        dispatch(appActions.toggleSpinner({value: true}));
        await getFilters()
            .then((filters: IFilter) => {
                const parsedFilters = parseFilters(filters);
                dispatch(appActions.toggleSpinner({value: false}));
                dispatch(filtersActions.getFiltersSuccess(filters));
                dispatch(filtersActions.setParsedFilters(parsedFilters));
            })
            .catch(() => {
                dispatch(appActions.toggleSpinner({value: false}));
                dispatch(filtersActions.getFiltersFailure());
            })
            .finally(() => {
                done();
            });
    }
});

export default [
    filtersLogic as Logic
];

const setTransportKind = () => {
    let transportkind: Array<{ name: string, shortName: string }> = [];
    store.getState().user.transporttypes.forEach((transport:ITransportType) => {
        transportkind.push({name:transport.title, shortName: transport.code});
    });
    return transportkind;
};


const parseFilters = (filters: IFilter): IParsedFilters => {
    // const transportkind: Array<{ name: string, shortName: string }> = [
    //     {name: "Автобус", shortName: "А"},
    //     {name: "Троллейбус", shortName: "Тб"},
    //     {name: "Трамвай", shortName: "Тм"},
    //     {name: "Автобус с электрическим двигателем", shortName: "Аэ"},
    // ];

    const transportkind: Array<{ name: string, shortName: string }> = setTransportKind();

    const parsedVehicle: IParsedVehicle = filters.vehicles
        .reduce((parsedItems: {
                     depotNumber: Array<{ depotNumber?: number, key?: number, primaryField?: number }>,
                     gosNomer: Array<{ gosNomer?: string, key?: string, primaryField?: string }>,
                     model: Array<{ model?: string, key?: string, primaryField?: string }>
                 },
                 vehicle: IVehicle) => ({
            depotNumber: [...parsedItems.depotNumber, {
                depotNumber: vehicle.depotNumber,
                key: vehicle.depotNumber,
                primaryField: vehicle.depotNumber
            }],
            gosNomer: [...parsedItems.gosNomer, {
                gosNomer: vehicle.gosNomer,
                key: vehicle.gosNomer,
                primaryField: vehicle.gosNomer
            }],
            model: [...parsedItems.model, {
                model: vehicle.model,
                key:  vehicle.model,
                primaryField: vehicle.model
            }]
        }), {depotNumber: [], gosNomer: [], model: []});

    const parsedFilters: IParsedFilters = {
        branch: filters.branches ? filters.branches.map((branch: IBranch) => ({
            id: branch.id,
            name: branch.name,
            key: branch.id,
            primaryField: branch.name,
        })) : [],
        depot: filters.depots ? filters.depots.map((depot: IDepot) => ({
            id: depot.id,
            name: depot.name,
            key: depot.id,
            primaryField: depot.name
        })) : [],
        route: filters.routes ? filters.routes.map((route: IFilterRoute) => ({
            id: route.id,
            name: route.name,
            key: route.id,
            primaryField: route.name
        })) : [],
        routeType: transportkind.map((tkind: { name: string, shortName: string }) => ({
            name: tkind.name,
            shortName: tkind.shortName,
            key: tkind.shortName,
            primaryField: tkind.name
        })),
        depotNumber: parsedVehicle.depotNumber,
        gosNomer: parsedVehicle.gosNomer,
        model: parsedVehicle.model,
    };

    if (filters.vehicles) {
        filters.vehicles.forEach((vehicle: IVehicle) => {
            const depot = filters.depots.find((depot: IDepot) => vehicle.Depot_id === depot.id);
            vehicle.branch = depot ? depot.Branch_id : undefined;
            vehicle.model = vehicle.model;
        });
    }

    return parsedFilters;
};